// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"b5b09a99","67":"353a41a4","111":"2abfab97","246":"286d5f12","288":"1fdf9cad","389":"7292c470","392":"861cd387","422":"36cddaa8","553":"0f3b8dee","687":"d72e1ca9","805":"c0cccaec","855":"de4efc1e"}[chunkId] + ".chunk.js";
};